<template>
  <div>
    <el-dialog :visible.sync="showDialog" title="选择考核单品" center :show-close="false">
      <el-tabs v-model="activeName">
        <el-tab-pane label="全部" name="all">
          <div class="select-all">
            <el-checkbox v-model="selectAll"></el-checkbox>所有在售商品都参与考核
          </div>
        </el-tab-pane>
        <el-tab-pane label="Segment" name="Segment" :disabled="selectAll">
          <span slot="label" v-if="selectSegMent.length">
            <el-badge :value="selectSegMent.length" class="item">SegMent</el-badge>
          </span>
          <el-checkbox-group v-model="selectSegMent" class="segMent">
            <el-checkbox v-for="item in segMentList" :key="item.brandCode" :label="item.brandCode">{{item.brandName}}</el-checkbox>
          </el-checkbox-group>
        </el-tab-pane>
        <el-tab-pane label="主品牌" name="brand" :disabled="selectAll">
          <span slot="label" v-if="brandList.length">
            <el-badge :value="brandList.length" class="item">主品牌</el-badge>
          </span>
          <Brand ref="brand" @strBrand="strBrand" :selectedList="selectedBrandList"></Brand>
        </el-tab-pane>
        <el-tab-pane label="子品牌" name="subBrand" :disabled="selectAll">
          <span slot="label" v-if="subBrandList.length">
            <el-badge :value="subBrandList.length" class="item">子品牌</el-badge>
          </span>
          <SubBrand ref="subBrand" @strSubBrand="strSubBrand" :selectedList="selectedSubBrandList"></SubBrand>
        </el-tab-pane>
        <el-tab-pane label="SKU" name="SKU" :disabled="selectAll">
          <span slot="label" v-if="skuList.length">
            <el-badge :value="skuList.length" class="item">SKU</el-badge>
          </span>
          <Sku ref="sku" @strSku="strSku" :selectedList="selectedSkuList"></Sku>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="danger" @click="setStrSaleScope">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tradeApi from '@/api/trade.js'
import Brand from '@/views/trade/perfect2022/components/region-str-brand.vue'
import SubBrand from '@/views/trade/perfect2022/components/region-str-subBrand.vue'
import Sku from '@/views/trade/perfect2022/components/region-str-sku.vue'
export default {
  props: {
    scopeDataList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {
    Brand,
    SubBrand,
    Sku
  },
  data () {
    return {
      showDialog: false,
      activeName: 'all',
      brandList: [],
      subBrandList: [],
      skuList: [],
      valueList: [],
      selectAll: false,
      segMentInfo: {},
      segMentList: [],
      selectSegMent: []
    }
  },
  watch: {
    scopeDataList () {
      this.init()
    }
  },
  computed: {
    selectedBrandList () {
      if (this.scopeDataList.length) {
        return this.scopeDataList.find(item => {
          return item.type === '03'
        })?.code || []
      } else {
        return []
      }
    },
    selectedSubBrandList () {
      if (this.scopeDataList.length) {
        return this.scopeDataList.find(item => {
          return item.type === '04'
        })?.code || []
      } else {
        return []
      }
    },
    selectedSkuList () {
      if (this.scopeDataList.length) {
        return this.scopeDataList.find(item => {
          return item.type === '05'
        })?.code || []
      } else {
        return []
      }
    }
  },
  created () {

  },
  methods: {
    show () {
      this.init()
      this.showDialog = true
      this.getSegMentList()
      this.$refs.brand && this.$refs.brand.init()
      this.$refs.SubBrand && this.$refs.SubBrand.init()
      this.$refs.sku && this.$refs.sku.init()
    },
    close () {
      this.showDialog = false
    },
    init () {
      this.scopeDataList.find(item => {
        return item.type === '01'
      }) ? this.selectAll = true : this.selectAll = false
      this.selectSegMent = this.scopeDataList.find(item => {
        return item.type === '02'
      })?.code.map(item => {
        return item.brandCode
      }) || []
      this.brandList = this.scopeDataList.find(item => {
        return item.type === '03'
      })?.code || []
      this.subBrandList = this.scopeDataList.find(item => {
        return item.type === '04'
      })?.code || []
      this.skuList = this.scopeDataList.find(item => {
        return item.type === '05'
      })?.code || []
    },
    getSegMentList () {
      this.segMentList = []
      tradeApi.getStrSegment().then(res => {
        if (res.data.resultCode === '0') {
          this.segMentInfo = res.data.resultData.skuSegmentMap
          for (const i in this.segMentInfo) {
            let obj = {
              brandCode: i,
              brandName: this.segMentInfo[i]
            }
            this.segMentList.push(obj)
          }
        }
      })
    },
    setStrSaleScope () {
      this.valueList = []
      if (this.selectAll) {
        let obj = {
          type: '01',
          code: []
        }
        this.valueList.push(obj)
      } else {
        if (this.selectSegMent.length) {
          let list = []
          this.selectSegMent.forEach(item => {
            let obj = {
              brandCode: item,
              brandName: this.segMentInfo[item]
            }
            list.push(obj)
          })
          let obj = {
            type: '02',
            code: list
          }
          this.valueList.push(obj)
        }
        if (this.brandList.length) {
          let obj = {
            type: '03',
            code: this.brandList
          }
          this.valueList.push(obj)
        }
        if (this.subBrandList.length) {
          let obj = {
            type: '04',
            code: this.subBrandList
          }
          this.valueList.push(obj)
        }
        if (this.skuList.length) {
          let obj = {
            type: '05',
            code: this.skuList
          }
          this.valueList.push(obj)
        }
      }

      this.$emit('handleSetStrScope', this.valueList)
      this.showDialog = false
    },
    strBrand (val) {
      this.brandList = val
    },
    strSubBrand (val) {
      this.subBrandList = val
    },
    strSku (val) {
      this.skuList = val
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  min-width: 1000px !important;
  .el-dialog__header {
    border: none;
  }
}
::v-deep .el-tabs {
  .el-tabs__nav-wrap,
  .el-tabs__nav-scroll {
    overflow: visible;
    &:after {
      content: '';
      display: block;
      height: 0;
      clear: both;
      width: 100%;
      height: 2px;
      // visibility: hidden;
    }
  }
  .el-tabs__header {
    margin: 0;
  }
  .el-tabs__nav-wrap::after {
    background-color: #f3f5f9;
  }
  // 下方横线
  .el-tabs__active-bar {
    background-color: $base-red;
  }
  .el-tabs__item {
    width: 120px;
    text-align: center;
    padding: 0 30px !important;
    position: relative;
    .el-badge__content {
      position: absolute;
      right: -12px;
      min-width: 27px;
      box-sizing: border-box;
    }
  }
  .el-tabs__item .el-badge {
    width: 42px;
  }
  .el-tabs__item.is-active {
    background-color: #f9eaea;
    color: $base-red;
    font-weight: 700;
  }
  .el-tabs__item:hover {
    color: $base-red;
  }
}
.dialog-footer {
  text-align: center;
  margin-top: 20px;
}
.select-all{
  padding: 50px 200px;
  text-align: center;
  .el-checkbox{
    margin-right: 10px;
  }
}
.segMent {
  padding: 50px 0;
  text-align: center;
}
</style>
